import { Controller } from "@hotwired/stimulus"

// Switches between Navigation and Actions
// tabs in the mobile admin drawer.
export default class extends Controller {
  static targets = ["navPanel", "actionsPanel",
                     "navTab", "actionsTab"]

  connect() {
    this.showNav()
  }

  showNav() {
    this.navPanelTarget.classList.remove("hidden")
    this.actionsPanelTarget.classList.add("hidden")
    this.navTabTarget.classList.add(
      "bg-base-200", "font-semibold",
      "text-base-content"
    )
    this.navTabTarget.classList.remove(
      "text-base-content/50"
    )
    this.navTabTarget.setAttribute(
      "aria-selected", "true"
    )
    this.actionsTabTarget.classList.remove(
      "bg-base-200", "font-semibold",
      "text-base-content"
    )
    this.actionsTabTarget.classList.add(
      "text-base-content/50"
    )
    this.actionsTabTarget.setAttribute(
      "aria-selected", "false"
    )
  }

  showActions() {
    this.actionsPanelTarget.classList
      .remove("hidden")
    this.navPanelTarget.classList.add("hidden")
    this.actionsTabTarget.classList.add(
      "bg-base-200", "font-semibold",
      "text-base-content"
    )
    this.actionsTabTarget.classList.remove(
      "text-base-content/50"
    )
    this.actionsTabTarget.setAttribute(
      "aria-selected", "true"
    )
    this.navTabTarget.classList.remove(
      "bg-base-200", "font-semibold",
      "text-base-content"
    )
    this.navTabTarget.classList.add(
      "text-base-content/50"
    )
    this.navTabTarget.setAttribute(
      "aria-selected", "false"
    )
  }
}
